import Axios from 'axios';
import camelCaseKeysDeep from 'camelcase-keys-deep';
import axios from './axios';
import type { DeskBookingsPayload } from '../types';

export const getDeskBookings = (): Promise<DeskBookingsPayload> => (
  axios.get('/desk_bookings.json').then((response) => camelCaseKeysDeep(response.data))
);

export const getDeskLabelsByDate = (startDate: string, endDate: string, userId?: number): Promise<Record<string, string>> => (
  axios.get('/desk_bookings/calendar.json', { params: { start_date: startDate, end_date: endDate, user_id: userId } })
    .then((response) => response.data)
);

export const setDeskActive = (id: number, active: boolean): Promise<void> => (
  axios.put(`/desks/${id}.json`, { desk: { active } })
);

export const createDeskBooking = (params: { deskId: number, date: string, userId: number }): Promise<void> => (
  axios.post('/desk_bookings.json', { desk_booking: { desk_id: params.deskId, date: params.date, user_id: params.userId } })
);

export const moveDeskBooking = (id: number, deskId: number): Promise<void> => (
  axios.put(`/desk_bookings/${id}.json`, { desk_booking: { desk_id: deskId } })
);

export const deleteDeskBooking = (id: number): Promise<void> => axios.delete(`/desk_bookings/${id}.json`);

// Blocks all the given desks on one day, or none of them if any can't be blocked.
export const createDeskBlocks = (params: { deskIds: Array<number>, date: string, reason: string }): Promise<void> => (
  axios.post('/desk_blocks.json', { desk_block: { desk_ids: params.deskIds, date: params.date, reason: params.reason } })
);

export const deleteDeskBlocks = (ids: Array<number>): Promise<void> => (
  axios.delete('/desk_blocks.json', { params: { ids } })
);

export const extractErrorMessage = (error: unknown): string => (
  (Axios.isAxiosError(error) && error.response?.data?.errors?.join(' ')) || 'Something went wrong'
);
